import { createChildListViewContainer } from 'factories/ChildListView'
import documentActions from 'actions/documents'
import Component from 'components/Documents/ChildListView'

export default createChildListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    downloadItem: (params) => dispatch(documentActions.downloadItem(params)),
  }),
})(Component)
